import { render, staticRenderFns } from "./ParsedDocumentPopup.vue?vue&type=template&id=1b1cfd2e&scoped=true&lang=pug"
import script from "./ParsedDocumentPopup.vue?vue&type=script&lang=ts"
export * from "./ParsedDocumentPopup.vue?vue&type=script&lang=ts"
import style0 from "./ParsedDocumentPopup.vue?vue&type=style&index=0&id=1b1cfd2e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1cfd2e",
  null
  
)

export default component.exports